/** India dial-out: default +91; if number already starts with 91 (full intl), do not prepend again. */
export function buildDialoutPhoneParts(raw) {
  let d = String(raw || '').replace(/\D/g, '');
  d = d.replace(/^0+/, '');
  if (!d) {
    return { country_code: '+91', phone: '' };
  }
  if (d.startsWith('91') && d.length >= 12) {
    return { country_code: '+', phone: d };
  }
  if (d.length === 10) {
    return { country_code: '+91', phone: d };
  }
  if (!d.startsWith('91')) {
    return { country_code: '+91', phone: d };
  }
  return { country_code: '+', phone: d };
}

export function fullDialoutNumber(parts) {
  return `${parts.country_code || ''}${String(parts.phone).replace(/\D/g, '')}`;
}
